import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Router } from '@angular/router';
import { ApplicationRouteURL, WeGoConfig } from './../../shared/config';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';

@Component({
  selector: 'wego-driver-navbar',
  template: require('../views/driver-navbar.component.html'),
})

export class DriverNavBarComponent implements OnInit, OnDestroy {
  urlTAndCActivityLog: string;
  @Input('menu') menu: string;
  urlDriverUpdate: string;
  firstName: string;
  lastName: string;
  currentRole: string;
  personHashId: string;
  urlPersonUpdate: string;
  urlInbox: string;
  //selectedMenu: string;
  unreadNotification = 0;
  intervalHandler: any;
  language: string;
  menuCollapse: string;
  languageLbl: string;
  middleName: string;

  get selectedMenu() {
    return window.location.hash.split(/[;#]/)[1];
  }

  constructor(private router: Router
    , private authService: AuthService
    , private translateService: TranslateService) { }

  ngOnInit() {
    this.GetUserSetting();
    this.urlDriverUpdate = this.authService.GetURL(ApplicationRouteURL.URL_DRIVER_PROFILE);
    this.urlTAndCActivityLog = this.authService.GetURL(ApplicationRouteURL.URL_TERMS_CONDITION_ACTIVITY_DRIVER);
    this.urlInbox = this.authService.GetURL(ApplicationRouteURL.URL_INBOX_PAGE);
    this.intervalHandler = setInterval(() => this.GetNotificationCount(), (WeGoConfig.NOTIFICATION_REFRESH_INTERVAL_SEC * 1000));
    this.GetNotificationCount();

    this.language = this.translateService.currentLang == "en" ? "En" : this.translateService.currentLang == "de" ? "De" : this.translateService.currentLang == "pt" ? "Pt" : this.translateService.currentLang == "fr" ? "Fr" : this.translateService.currentLang == "pl" ? "Pl" : this.translateService.currentLang == "nl" ? "Du" : "Du";
    this.languageLbl = this.translateService.currentLang == "en" ? "EN" : this.translateService.currentLang == "de" ? "DE" : this.translateService.currentLang == "pt" ? "PT" : this.translateService.currentLang == "fr" ? "FR" : this.translateService.currentLang == "pl" ? "PL" : this.translateService.currentLang == "nl" ? "NL" : "NL";

    this.menuCollapse = "";
  }

  GetUserSetting() {
    let userSetting = this.authService.GetUserSetting();
    if (userSetting) {
      this.firstName = userSetting.firstName;
      this.lastName = userSetting.lastName;
      this.middleName = userSetting.middleName;
    }
    let userRole = this.authService.GetCurrentRole();
    if (userRole) {
      this.currentRole = userRole;
    }

    let personHashId = this.authService.GetPersonHashId();
    if (personHashId) {
      this.personHashId = personHashId;
    }
  }

  Logout() {
    clearInterval(this.intervalHandler);
    this.authService.Logout();
    this.router.navigate(['/']);
  }

  GetNotificationCount() {
    this.authService.GetNotificationCount()
      .subscribe(
      res => {
        this.unreadNotification = res.data;
      },
      error => {
        console.log(error);
      });
  }

  ResetNotificationCount() {
    this.authService.ResetNotificationCount()
      .subscribe(
      res => {
        if (res.data) {
          this.unreadNotification = 0;
        }
        this.router.navigate([this.urlInbox, { v: Date.now() }]);
      },
      error => {
        console.log(error);
      });
  }

  ChangeCurrentLanguage(language: string) {
    this.authService.UpdateUserLanguagePreference(language).subscribe(
      res => {
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
      },
      () => {
        localStorage.setItem("language", language);
        //this.translateService.setDetectedLang();
        
        this.language = this.translateService.currentLang == "en" ? "En" : this.translateService.currentLang == "de" ? "De" : this.translateService.currentLang == "pt" ? "Pt" : this.translateService.currentLang == "fr" ? "Fr" : this.translateService.currentLang == "pl" ? "Pl" : this.translateService.currentLang == "nl" ? "Du" : "Du";
        this.languageLbl = this.translateService.currentLang == "en" ? "EN" : this.translateService.currentLang == "de" ? "DE" : this.translateService.currentLang == "pt" ? "PT" : this.translateService.currentLang == "fr" ? "FR" : this.translateService.currentLang == "pl" ? "PL" : this.translateService.currentLang == "nl" ? "NL" : "NL";

        location.reload(true);
      });
  }

  ToggleCollapse() {
    this.menuCollapse = this.menuCollapse == "" ? "in" : "";
  }

  MenuSelected(selectedMenu: string) {
    //localStorage.setItem("driverSelectedMenu", selectedMenu);
  }

  GenerateDynamicURL(url: string) {
    let urlData = this.authService.GetURL(url);
    if (url == ApplicationRouteURL.URL_BOOKING)
      this.router.navigate([urlData, { v: Date.now() }]);
    else
      this.router.navigate([urlData]);
  }

  ngOnDestroy() {
    clearInterval(this.intervalHandler);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/driver-template/component/driver-navbar.component.ts